import { useRef, useState, useContext } from 'react';
import { Menu, Avatar, Box, Typography, Divider, useTheme, Switch, FormControlLabel } from '@mui/material';
import { useSelector } from 'react-redux';
import ButtonBasic from '../buttons/ButtonBasic';
import LogoutIcon from '@mui/icons-material/Logout';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { ColorModeContext } from '../../themes/themes';
const MenuUsuarioNav = ({
    onLogout
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const colorMode = useContext(ColorModeContext);

    const ref = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const user = useSelector((state) => state.auth.currentUser);
    return (
        <>
        <Avatar
            ref={ref}
            onClick={() => setIsOpen(true)}
            sx={{boxShadow:3,border:1,borderColor: isDarkMode ? '#3d4a62' : '#9d9ea4','&:hover': {cursor: 'pointer'}}}
            src={user?.foto_p}
        />

        <Menu
            open={isOpen}
            anchorEl={ref.current}
            onClose={() => setIsOpen(false)}
            PaperProps={{
                sx: {
                    width: 270,
                    background: isDarkMode ? '#1F2A40 !important' : '#fff !important',
                    boxShadow: 8,
                    border: isDarkMode ? '1px solid #3d4a62' : 'none'
                }
            }}
        >
            <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',flexDirection: 'column',mt:1}}>
                <Avatar
                    src={user?.foto_p}
                    sx={{width:90, height:90,boxShadow:6}}
                />
                <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#15294b',mt:2,fontWeight: 'bold'}} variant='h5'>{user?.nombre_p}</Typography>
                <Typography sx={{color: isDarkMode ? '#b0bec5' : '#15294b',mt:1}}>{`${user?.puesto_p || ''} - ${user?.razonSocial_p || ''}`}</Typography>
                <Typography sx={{color: isDarkMode ? '#b0bec5' : '#15294b',mt: 1}}>{user?.email_p}</Typography>
            </Box>
            <Divider sx={{background: isDarkMode ? '#3d4a62' : 'gray',mb:1}} />
            
            <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2}}>
                <Box 
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        padding: '8px 16px',
                        borderRadius: 3,
                        background: isDarkMode ? '#2d3a52' : '#f5f5f5',
                        transition: 'all 0.3s ease'
                    }}
                >
                    <LightModeIcon sx={{ color: !isDarkMode ? '#f59e0b' : '#b0bec5', fontSize: 20 }} />
                    <Switch
                        checked={isDarkMode}
                        onChange={colorMode.toggleColorMode}
                        sx={{
                            '& .MuiSwitch-switchBase': {
                                color: isDarkMode ? '#b0bec5' : '#f59e0b',
                                '&:hover': {
                                    backgroundColor: isDarkMode ? 'rgba(100, 181, 246, 0.08)' : 'rgba(245, 158, 11, 0.08)',
                                },
                            },
                            '& .MuiSwitch-switchBase.Mui-checked': {
                                color: '#64B5F6',
                                '&:hover': {
                                    backgroundColor: 'rgba(100, 181, 246, 0.08)',
                                },
                            },
                            '& .MuiSwitch-switchBase + .MuiSwitch-track': {
                                backgroundColor: isDarkMode ? '#3d4a62' : '#cbd5e0',
                                opacity: 1,
                            },
                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                backgroundColor: isDarkMode ? '#1F2A40' : '#4a5568',
                                opacity: 1,
                            },
                        }}
                    />
                    <DarkModeIcon sx={{ color: isDarkMode ? '#64B5F6' : '#b0bec5', fontSize: 20 }} />
                </Box>
            </Box>
            
            <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',flexDirection: 'column'}}>
                {user?.grupos?.length > 0 &&(
                    user?.grupos?.map((gr,index)=>(
                        <Typography key={`${index}TextG`} sx={{color: isDarkMode ? '#e0e0e0' : '#15294b',fontWeight: 'bold'}}>{`Grupo ${index +1}: ${gr?.nombre_g}`}</Typography>
                    ))
                )}
            </Box>
            <Box sx={{display: 'flex', justifyContent:'center',alignItems:'center',mt:2}}>
                <ButtonBasic
                    textButton='Cerrar Sesion'
                    onClick={()=>onLogout()}
                    variant="wk"
                    color='nextWhite'
                    sx={{
                        width: 200,
                        fontWeight: 'bold',
                        border:1,
                        borderColor: isDarkMode ? '#3d4a62' : '#a6aebb',
                        color: isDarkMode ? '#64B5F6' : '#15294b'
                    }}
                    iconStart={<LogoutIcon />}
                />
            </Box>
        </Menu>
        </>
    );
}

export default MenuUsuarioNav